import React from 'react';
import useQuery from "../../../hooks/useQuery";
import OrderModeStatic from "./OrderModeStatic";
import OrderDelivery from "./OrderDelivery";
import OrderPickup from "./OrderPickup";
import './delivery.css'

function OrderMode() {
    const query = useQuery()

    return (
          <>
              <OrderModeStatic mode={query.get('mode')}/>
              <div className='pt-2 px-3'>
                  <OrderDelivery mode={query.get('mode')}/>
                  <OrderPickup mode={query.get('mode')}/>
              </div>
          </>
    );
}

export default OrderMode;